import RouterNav from "./Router";
import Headers from "./Layout/Headers";
import Footer from "./Layout/Footer";
import React from "react";
import MessageDisplay from "./components/MessageDisplay";
import "bootstrap-icons/font/bootstrap-icons.css"
import ScrollToTop from "./Pages/ScrollTop/ScrollToTop";
function App() {
  return (
    <>
      <Headers />
      <MessageDisplay />
      <RouterNav />
      <Footer />
      <ScrollToTop/>
    </>
  );
}

export default App;
